export default {
	"148948b5cdc037944bca63935fdeb8cd": "Confirm the order at the checkout counter - add address",
	"b19b7c16503a95e44c8e6b51162bbeae": "Confirm the order at the checkout counter - select the address",
	"f8d4cb146e6407435ddab35663f9b64d": "There is no delivery address for the moment",
	"4895ae1b1fee46c1699af916adc1b797": "Add address"
}
